/**
 * 平台检测中间件
 */

export default function ({
  req, store, redirect, res,
}) {
  // 客户端环境不执行
  if (process.client) return;

  const userAgent = req.headers['user-agent'];
  // const platform = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) ? 'touch' : 'pc';
  // const platform = (/Android(?=.*Mobile)|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) ? 'touch' : 'pc';
  const isTouchDevice = /Android(?=.*Mobile)|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|ThinkParent/i.test(userAgent);
  const platform = isTouchDevice ? 'touch' : 'pc';
  store.commit('SET_PLATFORM', platform);

  // 获取当前请求URL和域名信息
  const requestUrl = req.ctx.request.url;
  const currentHost = req.headers.host;

  // 获取配置的域名信息
  const touchDomains = process.env.touchDomains || {};
  const pcDomains = process.env.pcDomains || {};
  const currentLocale = store.state.locale;

  // 获取当前语言环境对应的域名
  const touchDomain = touchDomains[currentLocale];
  const pcDomain = pcDomains[currentLocale];

  // PC端访问移动端域名，重定向到PC端域名
  if (!isTouchDevice && touchDomain && touchDomain.includes(currentHost)) {
    const pcUrl = `${pcDomain}${requestUrl}`;
    console.log(`PC端设备访问移动端域名，重定向到: ${pcUrl}`);
    if (process.server) {
      res.writeHead(301, { Location: pcUrl });
      res.end();
    } else {
      redirect(301, pcUrl);
    }
  }
}
